var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('button',{staticClass:"container",class:{'is-Selected' : _vm.selected},attrs:{"role":"checkbox","aria-checked":_vm.selected},on:{"click":function($event){return _vm.select()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }